import ModuleWrapperBody from "./ModuleWrapperBody";

export default ModuleWrapperBody;
